import {
    createSchemaModels,
    createBuilders,
    RulesModel,
    baseSnippetSchema as snippetSchema, // if we have vertical specific snippets we need to merge, but this would do for now.
    baseRulesSchema
} from 'ctm-vertical-base';

import {
    formElementFactory,
    FormSchemaModel,
    ValidationModel
} from 'ctm-builders';

import pageSchema from '../schemas/page_schema.json';
import progressionSchema from '../schemas/progression_schema.json';
import quoteFormSchema from '../schemas/form/quote_form_schema.json';
import callMeBackFormSchema from '../schemas/form/call_me_back_form_schema.json';
import layoutSchema from '../schemas/layout';
import rulesSchema from '../schemas/rules_schema.json';
import componentSchema from '../schemas/component';
import layoutComponentMappingSchema from '../schemas/layout_component_mapping.json';
import * as allWhiteLabelSchemaOverrides from '../schemas/white_labels';

const themeName = process.env.EVEREST_THEME?.trim();
let schemaOverrides = {};
if (themeName && themeName !== 'ctm') {
    if (!Object.keys(allWhiteLabelSchemaOverrides.default).includes(themeName)) {
        // eslint-disable-next-line no-console
        console.warn(`Theme: ${themeName} is specified but there are no schema overrides available for this theme - HnC`);
    } else {
        schemaOverrides = allWhiteLabelSchemaOverrides.default[themeName];
    }
}

// Merge rules schema together, can't use immutable.mergeDeep here because it overrides the array by default
rulesSchema.baseRules.push(...baseRulesSchema.baseRules);
rulesSchema.dynamicRules.push(...baseRulesSchema.dynamicRules);
rulesSchema.compoundRules.push(...baseRulesSchema.compoundRules);

const rulesModel = new RulesModel(rulesSchema);
const formSchemaModel = new FormSchemaModel(rulesModel, schemaOverrides.form || {}, schemaOverrides.quoteFormSchema || quoteFormSchema, callMeBackFormSchema);
const validationModel = new ValidationModel(formSchemaModel);

/**
* Write a desc
* @type {{formSchemaModel: *[], validationModel: *[], pageSchemaModel: *[], snippetModel: *[]}}
*/
const modelConfig = {
    pageSchemaModel: [schemaOverrides.pageSchema || pageSchema],
    snippetModel: [snippetSchema],
    layoutSchemaModel: [layoutSchema, schemaOverrides.layoutComponentMappingSchema || layoutComponentMappingSchema],
    componentSchemaModel: [componentSchema, schemaOverrides.components || {}],
    progressionModel: [progressionSchema]
};

/**
* Write a desc
*/
export const models = Object.assign(
    createSchemaModels(modelConfig),
    { rulesModel, formSchemaModel, validationModel }
);

/**
* Setup the builders used by the vertical
* @type {{form: Array, page: [*], layout: [*], component: [*]}}
*/
const builderConfig = {
    form: [],
    page: [models.pageSchemaModel],
    layout: [models.layoutSchemaModel],
    component: [models.componentSchemaModel]
};

export const builders = createBuilders(builderConfig);

export const factories = { formElement: formElementFactory };
